import { Box, FormControl, TextField } from "@mui/material"
import { useEffect, useState } from "react"
import { AffiliateNetworkConfig, ImpactConfig, MerchantAffiliateNetwork } from "src/types/merchants"
import { encryptWithPubkey } from "src/utils/rsa"

interface ImpactInputFormProps {
  handleAffiliateNetworkConfigChange: (newConfig: AffiliateNetworkConfig) => void
  existingConfig: AffiliateNetworkConfig
}

const ImpactInputForm: React.FC<ImpactInputFormProps> = ({handleAffiliateNetworkConfigChange, existingConfig}) => {
  const [programId, setProgramId] = useState(existingConfig.impact?.programId)
  const [accountSid, setaccountSid] = useState('')
  const [encryptedAccountSid, setEncryptedAccountSid] = useState('')
  const [apiKey, setApiKey] = useState('')
  const [encryptedApiKey, setEncryptedApiKey] = useState('')

  // encrypt the api key as the user makes changes to it
  useEffect(() => {
    if (!apiKey) {
      setEncryptedApiKey('')// no need to encrypt an empty string
    }  else {
      setEncryptedApiKey(encryptWithPubkey(apiKey))
    }
  },[apiKey])

  // encrypt the account sid as the user makes changes to it
  useEffect(()=> {
    if (!accountSid) {
      setEncryptedAccountSid('')// no need to encrypt an empty string
    }  else {
      setEncryptedAccountSid(encryptWithPubkey(accountSid))
    }
  },[accountSid])

  // set the state in the merchant object
  useEffect(() => {
    const newConfig = {
      type: MerchantAffiliateNetwork.IMPACT,
      impact: {
        programId: programId,
        accountSid: {
          transportEncrypted: encryptedAccountSid,
        },
        apiKey: {
          transportEncrypted: encryptedApiKey,
        },
      } as ImpactConfig
    }

    handleAffiliateNetworkConfigChange(newConfig)
  },[encryptedApiKey, encryptedAccountSid, programId,handleAffiliateNetworkConfigChange])


  return (
    <Box>
      <FormControl className="formControlsContainer">
          <TextField
            value={programId}
            onChange={(e) => {
              setProgramId(e.target.value)
            }}
            label='Impact Program ID'
            variant="outlined"
          />
        </FormControl>
        <FormControl className="formControlsContainer">
        <TextField
          value={accountSid}
          onChange={(e) => {
            setaccountSid(e.target.value)
          }}
          label='Impact Account SID'
          variant="outlined"
        />
      </FormControl>
        <FormControl className="formControlsContainer">
          <TextField
            value={apiKey}
            onChange={(e) => {
              setApiKey(e.target.value)
            }}
            label='Impact Auth Token'
            variant="outlined"
          />
        </FormControl>
    </Box>
  )
}

export default ImpactInputForm